<template>
  <span>
    <b-card no-body>
      <b-card-header>
        <b-row>
          <b-col md="9">
            <h3>Gerenciar Depoimentos</h3>
          </b-col>
          <b-col md="3">
            <p><b>Nome:</b> {{ usuario.nome }}</p>
            <p><b>Perfil:</b> {{ usuario.perfil.nome }}</p>
          </b-col>
        </b-row>
      </b-card-header>
      <b-card-body>
        <b-row>
          <b-col md="5">
            <b-form-group label="Perfil:">
              <b-form-select
                v-model="filtros.tipo"
                placeholder="Perfil"
                class="mb-3"
              >
                <option selected :value="null">Selecione</option>
                <option
                  v-for="item in listacombo"
                  :key="item.id"
                  :value="item.id"
                >
                  {{ item.nome }}
                </option>
              </b-form-select>
            </b-form-group>
          </b-col>
          <b-col md="5">
            <b-form-group label="Selecione Município:">
              <b-form-select
                v-model="filtros.municipioAtuacao"
                placeholder="Selecione Município"
                class="mb-3"
              >
                <option selected :value="null">Selecione</option>
                <option
                  v-for="item in municipiosprogramas"
                  :key="item.id"
                  :value="item.municipio_id"
                >
                  {{ item.cidade.cidade + " - " + item.estado.sigla }}
                </option>
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="5">
            <b-form-group>
              <b-form-group label="Nome do usuário:">
                <b-form-select v-model="filtros.user" class="mb-3">
                  <option
                    v-for="item in listusers"
                    :key="item.id"
                    :value="item.id"
                  >
                    {{ item.nome }}
                  </option>
                  <option selected :value="null">Selecione</option>
                </b-form-select>
              </b-form-group>
            </b-form-group>
          </b-col>
          <b-col sm="5">
            <b-form-group>
              <b-form-group label="Situação:">
                <b-form-select v-model="filtros.situacao" class="mb-3">
                  <option
                    v-for="item in listaSituacao"
                    :key="item.id"
                    :value="item.value"
                  >
                    {{ item.nome }}
                  </option>
                  <option selected :value="null">Selecione</option>
                </b-form-select>
              </b-form-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="2">
            <b-button @click="limpafiltro" block variant="cinza">
              <i class="fa fa-eraser"></i>
              <span>Limpar filtros</span>
            </b-button>
          </b-col>
          <b-col md="2">
            <b-button @click="pesquisar" block variant="primary">
              <i class="fa fa-search"></i>
              <span>Pesquisar</span>
            </b-button>
          </b-col>
        </b-row>
      </b-card-body>
      <b-row>
        <b-col sm="12">
          <b-container fluid>
            <span>
              <b-form-select style="width: 100px; float: right" class="mb-3" v-model="totalPorPagina" :options="totalSelectOp"></b-form-select>
              <table
                aria-rowcount="4"
                id="my-table"
                aria-busy="false"
                aria-colcount="7"
                class="
                  table
                  table-responsive-sm
                  table-bordered
                  table-striped
                  table-sm
                "
              >
                <thead>
                  <tr>
                    <th scope="col">Perfil</th>
                    <th scope="col">Nome</th>
                    <th scope="col">Depoimento</th>
                    <th scope="col">Situação</th>
                    <th scope="col">Ações</th>
                  </tr>
                </thead>
                <tbody v-if="depoimentos.data !== undefined">
                  <tr
                    v-for="depoimento in depoimentos.data"
                    :key="depoimento.id"
                  >
                    <td>{{ depoimento.perfil }}</td>
                    <td>{{ depoimento.nome }}</td>
                    <td style="width: 15%">
                      <a
                        class="btn btn-sm btn-secondary action"
                        title="Visualizar Depoimento"
                        @click="visualizar(depoimento.id)"
                      >
                        <i class="fa fa-eye"></i>
                      </a>
                    </td>
                    <td>{{ TipoSituacao(depoimento.ativo) }}</td>
                    <td style="width: 15%">
                      <span v-if="depoimento.ativo">
                        <a
                          class="btn btn-sm btn-secondary action"
                          title="Desativar Depoimento"
                          @click="desativar(depoimento.id)"
                        >
                          <i class="fa fa-toggle-on"></i>
                        </a>
                      </span>
                      <span v-if="!depoimento.ativo">
                        <a
                          class="btn btn-sm btn-secondary action"
                          title="Ativar Depoimento"
                          @click="ativar(depoimento.id)"
                        >
                          <i class="fa fa-toggle-off"></i>
                        </a>
                      </span>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr class="action">
                    <td colspan="5">Nenhum registro de depoimentos...</td>
                  </tr>
                </tbody>
              </table>
              <pagination
                v-show="depoimentos.data !== undefined"
                :totalPorPagina="totalPorPagina"
                :resource="resource"
                :filtros="filtros"
              ></pagination>
            </span>
          </b-container>
        </b-col>
      </b-row>
      <b-modal title="Depoimento" :hide-footer="true" hide-header-close v-model="modal">
            <b-card-body>
                 <b-col sm="12">
                <b-container fluid>
                       <span>
                        <i class="fa fa-quote-left mr-3"></i>{{descricao}}
                       </span>
                </b-container>
                 </b-col>
           </b-card-body>
           <b-card-footer class="p-12 text-center">
                <b-button variant="secondary" @click="fecharModal"><i class="fa fa-times">&nbsp;</i> Fechar</b-button>
           </b-card-footer>
        </b-modal>
    </b-card>
  </span>
</template>

<script>
import Vue from 'vue'
import Pagination from '@/components/shared/PaginationAvaliacoes'
import { eventType } from '@/components/shared/eventType'
import miniToastr from 'mini-toastr'
import SessionStorage from '@/services/session-storage'

miniToastr.init()

export default {
  components: {
    Pagination
  },
  created () {
    if (SessionStorage.get('tipoPerfil').replace(/['"]+/g, '') === 'A') {
      this.$store.dispatch('buscarMunicipiosProgramas')
      this.$store.dispatch('getUsuario', SessionStorage.get('usuario'))
      this.getUser()
    } else {
      this.$router.push('/')
    }
  },
  data () {
    return {
      mainProps: { width: 250, height: 250 },
      countadorErros: 0,
      totalPorPagina: 20,
      totalSelectOp: [
        {text: '20', value: 20},
        {text: '30', value: 30},
        {text: '50', value: 50},
        {text: '100', value: 100}
      ],
      resource: 'depoimentos',
      disabled_cidades: true,
      modal: false,
      descricao: '',
      listusers: [],
      filtros: {
        tipo: null,
        user: null,
        situacao: null,
        municipioAtuacao: null
      },
      listacombo: [{
        id: 4, nome: 'Voluntária'
      }, {
        id: 5, nome: 'Beneficiária'
      }],
      listaSituacao: [
        { id: 1, nome: 'Ativo', value: true },
        { id: 2, nome: 'Inativo', value: false }
      ]
    }
  },
  computed: {
    municipiosprogramas () {
      return this.$store.state.municipiosprogramas.listaMunicipiosProgramas
    },
    depoimentos () {
      if (this.$store.state.pagination.getList.data !== undefined) {
        if (this.$store.state.pagination.getList.data.length !== 0) {
          return this.$store.state.pagination.getList
        } else {
          return false
        }
      }
      return this.$store.state.pagination.getList
    },
    usuario () {
      return this.$store.state.usuario.usuarioEditar
    }
  },
  watch: {
    'filtros.municipioAtuacao': function () {
      this.setarFiltros(this.filtros)
      this.getUser()
    },
    'filtros.tipo': function () {
      this.setarFiltros(this.filtros)
      this.getUser()
    }
  },
  methods: {
    setarFiltros (filtros) {
      eventType.$emit('app', filtros)
    },
    pesquisar () {
      this.$store.dispatch('getRegistrosSearch', {
        resource: this.resource,
        limit: this.totalPorPagina,
        filtros: this.filtros
      })
      this.setarFiltros(this.filtros)
    },
    limpafiltro () {
      this.filtros = {
        tipo: null,
        user: null,
        situacao: null,
        municipioAtuacao: null
      }
      this.pesquisar()
    },
    fecharModal () {
      this.modal = false
    },
    openModal () {
      this.modal = true
    },
    getUser () {
      Vue.http
        .get('api/depoimentos-users', { params: this.filtros })
        .then((response) => {
          this.listusers = response.body.data[0]
        })
    },
    TipoSituacao (data) {
      if (data) return 'Ativo'
      return 'Inativo'
    },
    visualizar (id) {
      Vue.http.get('api/feedbacks/' + id).then(response => {
        this.descricao = response.body.data[0].texto
        this.openModal()
      })
    },
    desativar (id) {
      this.$bvModal.msgBoxConfirm('Confirma a desativação do depoimento selecionado?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          Vue.http.get('api/depoimentos/desativar/' + id).then(response => {
            if (response.body.success) {
              miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
              miniToastr.success(response.body.msg, 'Sucesso!', 7000)
              this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
            }
          })
        }
      }).catch(erro => {
        if (!erro.body.success) {
          miniToastr.setIcon('error', 'i', {'class': 'fa fa-check'})
          miniToastr.error(erro.body.msg, 'Alerta!', 7000)
          this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
        }
      })
    },
    ativar (id) {
      this.$bvModal.msgBoxConfirm('Confirma a ativação do depoimento selecionado?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          Vue.http.get('api/depoimentos/ativar/' + id).then(response => {
            if (response.body.success) {
              miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
              miniToastr.success(response.body.msg, 'Sucesso!', 7000)
              this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
            }
          })
        }
      }).catch(erro => {
        if (!erro.body.success) {
          miniToastr.setIcon('error', 'i', {'class': 'fa fa-check'})
          miniToastr.error(erro.body.msg, 'Alerta!', 7000)
          this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
        }
      })
    },
    navigate (route) {
      this.$router.push(route)
    }
  }
}
</script>

<style scoped>
.action {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/site/interna/administrador/depoimentos/depoimento.vue